import { render } from "./RecipeDetailView.vue?vue&type=template&id=77c2d8d6&scoped=true&ts=true"
import script from "./RecipeDetailView.vue?vue&type=script&lang=ts"
export * from "./RecipeDetailView.vue?vue&type=script&lang=ts"

import "./RecipeDetailView.vue?vue&type=style&index=0&id=77c2d8d6&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c2d8d6"]])

export default __exports__